var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.18.3l.1.1 3.96 3.93a1.36 1.36 0 01-1.8 2.03l-.12-.1-3-3L4.53 8l4.78 4.74 3-2.99a1.36 1.36 0 011.92 1.93l-3.95 3.93c-.54.53-1.4.53-1.93 0l-.06-.07-.07-.07-5.5-5.44v3.26a1.36 1.36 0 01-2.72 0V2.7a1.36 1.36 0 012.72 0v3.25L8.23.52l.12-.11h.01c.5-.5 1.28-.54 1.81-.11zm-.84 6.33a1.37 1.37 0 110 2.74 1.37 1.37 0 010-2.74z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuCoin);
export default __webpack_public_path__ + "static/media/KuCoin.4300e2b9.svg";
export { ForwardRef as ReactComponent };